import { useEffect, useState } from "react";
import { Box, Heading, Spinner, Center } from "@chakra-ui/react";
import StatsHeader from "./StatsHeader";
import WorkflowsTable from "./WorkflowsTable";
import { getAlltoken_data, getAllworkflows_Data } from "../../allApi/api";
import NoDataMessage from "../../components/EmptyData.jsx/EmptyData";
import { useSelector } from "react-redux";
import FeatureLockedMessage from "../../featureLockMessage/FeatureLockedMessage";

const ObservabilityDashboard = () => {
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({});
  const [workflows, setWorkflows] = useState([]);
  const userPlanDetails = useSelector(
    (state) => state?.userDetails?.userPlanDetails
  );

  useEffect(() => {
    const fetchTokenData = async () => {
      try {
        const [tokenData, allWorkFlowsData] = await Promise.all([
          getAlltoken_data(),
          getAllworkflows_Data(),
        ]);

        setStats(tokenData);
        setWorkflows(allWorkFlowsData);
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };
    fetchTokenData();
  }, []);


  if (userPlanDetails?.observability == false) {
    return <FeatureLockedMessage featureName="AI Co-Worker" />;
  }


  if (loading) {
    return (
      <Center h="100vh">
        <Spinner size="xl" />
      </Center>
    );
  }

  if (!stats?.success || workflows?.error) {
    return <NoDataMessage />;
  }

  return (
    <Box p={3} h={"100%"}>
      <Heading size="md" mb={4}>
        Observability Dashboard
      </Heading>
      <Box h={"30%"}>
        <StatsHeader stats={stats} />
      </Box>

      <Box h={"60%"}>
        <WorkflowsTable workflows={workflows} />
      </Box>
    </Box>
  );
};

export default ObservabilityDashboard;
